var codeblock_default = {
  "blockStyleSpacing": "UIxfV",
  "codeBlock": "KMNrE UIxfV",
  "renderedInTable": "LiMo-"
};
export {
  codeblock_default as default
};
//# sourceMappingURL=codeblock-scss.js.map
